import { createSvgIcon } from '@mui/material';

export const CopyIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.39909 18.3005C3.94076 18.3005 3.54839 18.1373 3.22201 17.8109C2.89562 17.4845 2.73242 17.0922 2.73242 16.6338V4.96715H4.39909V16.6338H13.5658V18.3005H4.39909ZM7.73242 14.9672C7.27409 14.9672 6.88173 14.804 6.55534 14.4776C6.22895 14.1512 6.06576 13.7588 6.06576 13.3005V3.30049C6.06576 2.84215 6.22895 2.44979 6.55534 2.1234C6.88173 1.79701 7.27409 1.63382 7.73242 1.63382H15.2324C15.6908 1.63382 16.0831 1.79701 16.4095 2.1234C16.7359 2.44979 16.8991 2.84215 16.8991 3.30049V13.3005C16.8991 13.7588 16.7359 14.1512 16.4095 14.4776C16.0831 14.804 15.6908 14.9672 15.2324 14.9672H7.73242Z"
      fill="currentColor"
    />
  </svg>,
  'CopyIcon',
);
